import {
  EmptyStateIcon,
  ExtendedTypography,
} from '@issuemanager/apps/client/components';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { Link as MUILink, Stack } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
  onEdit?: () => void;
  description: string;
};

export function EmptyWorkflowState({ onEdit, description }: Props) {
  const { t } = useTranslation(['common']);
  const semantic = useAtlasSemanticThemeTokens();

  return (
    <Stack
      spacing={1.5}
      justifyContent='center'
      alignItems='center'
      data-testid='empty-state'
    >
      <EmptyStateIcon />
      <Stack spacing={1.5} alignItems='center'>
        <ExtendedTypography fontWeight='medium'>
          {t('common:table.empty')}
        </ExtendedTypography>
        <ExtendedTypography
          variant='body2'
          color={semantic.color.text.muted.value}
        >
          <Trans
            t={t}
            i18nKey={description}
            components={{
              editBtn: (
                <MUILink
                  component='button'
                  onClick={onEdit}
                  data-testid='edit-issue-btn'
                  sx={{ pointerEvents: 'auto', verticalAlign: 'bottom' }}
                />
              ),
            }}
          />
        </ExtendedTypography>
      </Stack>
    </Stack>
  );
}
